<template lang="pug">
  .user-feedback
    .user-feedback__title
      h1.title Обратная связь
    .user-feedback__main
      .profile-page-form
        .profile-page-form__section-container
          section.profile-page-form__section.profile-section
            .profile-section__body
              feedback-form
</template>

<script>
import FeedbackForm from "../../../../components/feedback-form/feedback-form.vue";
export default {
  name: "user-feedback",
  components: {
    FeedbackForm,
  },
};
</script>
